var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecurrence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.612915,17.03602L11.165894,21.178967 8.6329346,22.906019C10.704956,24.631973     13.351929,25.667984 16.11499,25.667984 21.409912,25.667984 26.012939,22.32997 27.16394,17.610972L27.279907,17.265024     27.281006,17.265024 32,17.265024 31.769897,17.956003C30.50293,24.977982 23.828003,29.696001 16.115967,29.696001     11.741943,29.696001 7.7130127,28.084978 4.7209473,25.323013L2.532959,26.703995z     M15.883911,0C20.256958,-1.2778764E-07,24.286011,1.6109628,27.278931,4.3739649L29.465942,2.8770155     30.385986,12.200019 20.833008,8.6319629 23.365967,7.021C21.293945,5.2940093 18.646973,4.3739649     15.88501,4.3739649 10.589966,4.3739649 5.9859619,7.94196 4.8349609,12.661018L4.8339844,12.661995     4.6040039,13.352974 0,13.352974 0.22900391,12.200996C1.4959717,5.1799957,8.1708984,0.11596674,15.883911,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurrence);
export default __webpack_public_path__ + "static/media/recurrence.ddada959756ed43f26fb3627fc5a6e07.svg";
export { ForwardRef as ReactComponent };